function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { Directions } from "common/components/drop-menu/types";
import { CopyType } from "./types";
export function template() {
  const icon = this.attr("icon") || (this.attr("copy-type") === CopyType.Copy ? "copy" : "link");
  if (this.attr("options").length === 1) {
    return /* @__PURE__ */ jsx("div", { sel: ".copy-to-clipboard-button" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: _objectSpread(_objectSpread({}, this.attrs()), {}, {
      icon
    }), on: {
      click: () => this.helpers.copyValue(this.attr("options")[0].value)
    } }, this.innerHTML.trim() && /* @__PURE__ */ jsx("slot", null)), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      "max-width": "64px",
      text: this.t("components.copy-to-clipboard.copy")
    } }));
  }
  return /* @__PURE__ */ jsx(SelectEl, { sel: ".copy-to-clipboard-select", attrs: {
    sections: [{
      items: this.attr("options").map((option) => ({
        label: option.label,
        value: option.value
      }))
    }],
    "icon-only": true,
    icon: {
      leftIcon: icon
    },
    "menu-width": 200,
    "menu-alignment": Directions.Up
  }, on: {
    change: (ev) => this.helpers.copyValue(ev.detail.item.value)
  }, "data-sentry-element": "SelectEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" });
}
